<template>
  <div
    class="input-text flex flex-row items-center  border relative transition-all max-w-full cursor-pointer "
    :class="
      heightClass + ' ' + borderClass + ' ' + focusWithinClass + ' ' + isLoading
    "
    @click="focusInput"
  >
    <div class="absolute top-3 left-3 flex-shrink-0">
      <slot name="icon" v-if="$slots.icon != null"> </slot>
    </div>
    <div
      class=" min-w-full whitespace-nowrap overflow-hidden overflow-ellipsis"
      :class="[inputClass + ' ', $slots.icon != null ? 'pl-9' : '']"
      v-if="!state.showInput && type == 'price'"
    >
      {{ valueToPrice }}
    </div>

    <input
      :type="type == 'price' || type == 'minutes' ? 'number' : type"
      ref="input"
      class="bg-transparent border-none w-full h-11 rounded-xl"
      :class="[
        inputClass + ' ',
        $slots.icon != null ? 'pl-9' : '',
        !state.showInput && type == 'price' ? ' max-h-0 ' : '',
      ]"
      :id="id"
      :name="name"
      :value="modelValue"
      :autocomplete="'off'"
      @input="updateInput"
      @change="changeInput"
      @focus="focus"
      @blur="state.showInput = false"
      @keydown.enter="$emit('enter')"
    />
    <label
      @click="$emit('click')"
      :for="id"
      class="text-grey absolute transition-all px-1 left-2"
      :class="[
        (modelValue && modelValue != '') || type == 'date'
          ? labelClass + ' -top-3 text-sm'
          : resetLabelTopPosition
          ? 'text-md'
          : 'top-2 text-md',
        $slots.icon != null && (!modelValue || modelValue == '')
          ? 'left-8'
          : '',
      ]"
      >{{ label }}</label
    >
  </div>
</template>

<script>
import { computed, defineComponent, reactive, ref } from "vue";
import { useStore } from "vuex";
import { formatNumberToPrice } from "../../common/dataHelper";
import { HELPER_TYPES, STORE_TYPES } from "../../store/types";
export default defineComponent({
  components: {},
  name: "InputText",
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: false,
    },
    modelValue: {
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    labelClass: {
      type: String,
      default: "",
    },
    resetLabelTopPosition: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "text",
    },
    heightClass: {
      type: String,
      default: "h-11",
    },
    borderClass: {
      type: String,
      default: "border-grey-light hover:border-grey rounded-xl",
    },
    focusWithinClass: {
      type: String,
      default: "focus-within:border-grey",
    },
    inputClass: {
      type: String,
      default: "pl-3",
    },
  },
  emits: [
    "update:modelValue",
    "update:value",
    "change",
    "focus",
    "click",
    "enter",
  ],
  setup(props, ctx) {
    const store = useStore();

    /**
     * refs
     */
    const state = reactive({ showInput: false });
    const input = ref();
    /**
     * functions
     */
    function focusInput() {
      let activeItem = document.activeElement;
      if (input.value && input.value != activeItem) {
        input.value.focus();
      }
      // ctx.emit("click");
    }
    /**
     * emits
     */
    function updateInput(event) {
      REMOVE_ERROR_ID();
      const newValue = event.target.value;
      ctx.emit("update:modelValue", newValue);
    }
    function changeInput(event) {
      const newValue = event.target.value;
      ctx.emit("change", newValue);
    }
    function focus(event) {
      state.showInput = true;
      ctx.emit("focus", event);
    }

    function REMOVE_ERROR_ID() {
      if (errorMessage.value) {
        store.commit(
          `${STORE_TYPES.HELPERS}/${HELPER_TYPES.REMOVE_ERROR_ID}`,
          props.name
        );
      }
    }
    /**
     *  Computed
     */
    const errorMessage = computed(() => {
      const errorIds =
        store.getters[`${STORE_TYPES.HELPERS}/${HELPER_TYPES.GET_ERROR_IDS}`];
      let error = errorIds[props.name];
      if (error) {
        return error[0];
      }
      return error;
    });
    const isLoading = computed(() => {
      const loadingIds =
        store.getters[`${STORE_TYPES.HELPERS}/${HELPER_TYPES.GET_LOADING_IDS}`];
      let loading = loadingIds.find((loadingId) => loadingId == props.id);

      return loading ? "border-loading" : "";
    });
    const valueToPrice = computed(() => {
      return formatNumberToPrice(props.modelValue);
    });

    return {
      state,
      //refs
      input,
      //functions
      focusInput,
      REMOVE_ERROR_ID,
      //emits
      updateInput,
      changeInput,
      focus,
      //computed
      errorMessage,
      isLoading,
      valueToPrice,
    };
  },
});
</script>
<style lang="scss">
.border-loading {
  border-color: #0c7c59 !important;
  label {
    color: #0c7c59 !important;
  }
}
</style>
